module.exports = __webpack_public_path__ + "img/google-play.5721645c.png";